export default __webpack_public_path__ + "media/zurb/img/icons/favicon/mstile-150x150-8d1405d96947f103b8411aa4cbaeaa2e.png";